import styled from 'styled-components';
import COLORS from '../../../constants/COLORS';
import COLORS_MARKETPLACE from '../../../constants/COLORS_MARKETPLACE';
import mixins from '../../../styles/mixins';

export default {
  Container: styled.div`
    position: relative;

    border-top-left-radius: 20px;
    border-top-right-radius: 20px;

    background-color: ${COLORS.MARKETPLACE_GREY};

    @media (min-width: 768px) {
      width: 100%;

      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  `,
  MainContent: styled.div`
    padding: 20px 20px 70px 20px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    background-color: ${COLORS_MARKETPLACE.GREY};
  `,
  Section: styled.section`
    padding: 16px 0;

    & + & {
      margin-top: 4px;
    }

    & > ul {
      ${mixins.listReset}

      & > li {
        &:not(:last-child) {
          margin-bottom: 12px;
        }
      }
    }
  `,
  SectionTitle: styled.h3`
    ${mixins.h1}

    display: flex;
    align-items: center;
    margin: 0;
    margin-bottom: 24px;
    background-color: ${COLORS_MARKETPLACE.GREY};

    &::after {
      content: '';
      width: 100%;
      height: 1px;
      margin-left: 12px;
      border: 1px dashed rgba(0, 0, 0, 0.8);
      opacity: 0.1;
    }
  `,
};
